export default "__VITE_ASSET__8e15253b__"